import { CoreDataPoint } from "../../../Components/Shared/CoreComponents";

export enum DynamicOrderByDirection {
    Ascending = 'Ascending',
    Descending = 'Descending'
}

export default interface AdHocReportOrderByModel {
    coreTypeID: number;
    direction: DynamicOrderByDirection;
    orderedCoreDataPointModel: CoreDataPoint;
}
